<script>
import SiteHeader from "@/components/layout/SiteHeader.vue";
import SiteFooter from "@/components/layout/SiteFooter.vue";

export default {
  name: "PublicLayout",
  components: { SiteHeader, SiteFooter },
};
</script>

<template>
  <div class="d-flex flex-column min-vh-100">
    <SiteHeader />
    <main class="flex-grow-1">
      <router-view />
    </main>
    <SiteFooter />
  </div>
</template>
